/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActuatorService } from './services/actuator.service';
import { FlightTypeService } from './services/flight-type.service';
import { FlightReportService } from './services/flight-report.service';
import { FlightReportSubscriberService } from './services/flight-report-subscriber.service';
import { TicketSubscriberService } from './services/ticket-subscriber.service';
import { FeedbackTypeService } from './services/feedback-type.service';
import { FeedbackService } from './services/feedback.service';
import { TicketService } from './services/ticket.service';
import { TicketCommentService } from './services/ticket-comment.service';
import { DashboardService } from './services/dashboard.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActuatorService,
    FlightTypeService,
    FlightReportService,
    FlightReportSubscriberService,
    TicketSubscriberService,
    FeedbackTypeService,
    FeedbackService,
    TicketService,
    TicketCommentService,
    DashboardService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
